module.exports = __webpack_public_path__ + "custom-config/img/header_info_trading.5a30692.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/header/info/header_info_trading.jpg
// module id = 4Sm4
// module chunks = 2 3 4 6 7 8 9